import { render, staticRenderFns } from "./Infooutline.vue?vue&type=template&id=dd08b10c&"
import script from "./Infooutline.vue?vue&type=script&lang=js&"
export * from "./Infooutline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports